import React from 'react';
import { useSelector } from 'react-redux';
import { ConfigContext } from '../../../utils/config';
import * as Atoms from '../../atoms';
import * as Molecules from '../../molecules';
import * as Dumb from '../dumb';
const Footer = ({
  hasIncreasedPadding
}) => {
  const {
    onClose
  } = React.useContext(ConfigContext);
  const unifiedPrivacy = useSelector(state => state.unifiedPrivacy.value);
  const [initialPrivacy, setInitialPrivacy] = React.useState(null);
  React.useEffect(() => {
    if (unifiedPrivacy && !initialPrivacy) {
      setInitialPrivacy(unifiedPrivacy);
    }
  }, [unifiedPrivacy, initialPrivacy]);
  const settingsChanged = !!(unifiedPrivacy && initialPrivacy && (unifiedPrivacy.is_published !== initialPrivacy.is_published || unifiedPrivacy.is_reusable !== initialPrivacy.is_reusable));
  return React.createElement(Dumb.Footer, {
    onDismissClicked: onClose,
    settingsChanged: settingsChanged,
    hasIncreasedPadding: hasIncreasedPadding
  }, React.createElement(Molecules.Smart.SocialSharing, null), React.createElement(Atoms.Smart.EmbedButton, null));
};
export default Footer;